import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/expand.svg';
const Expand = () => React.createElement(IconSvg, null);
export default Expand;
